module.exports = __webpack_public_path__ + "img/women.5be2262d.png";